import { useLayoutEffect, useRef, useState, useCallback } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

export function PageTransition({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const prevPath = useRef(location.pathname);
  const [showGhost, setShowGhost] = useState(false);
  const [ghostKey, setGhostKey] = useState(0);

  useLayoutEffect(() => {
    if (location.pathname !== prevPath.current) {
      prevPath.current = location.pathname;
      window.scrollTo({ top: 0, behavior: 'instant' });
      setGhostKey((k) => k + 1);
      setShowGhost(true);
    }
  }, [location.pathname]);

  const handleGhostEnd = useCallback(() => {
    setShowGhost(false);
  }, []);

  return (
    <Box sx={{ minHeight: '100%', position: 'relative' }}>
      {children}

      {showGhost && (
        <Box
          key={ghostKey}
          onAnimationEnd={handleGhostEnd}
          sx={{
            position: 'absolute',
            inset: 0,
            zIndex: 10,
            bgcolor: '#050510',
            animation: 'ghostFadeOut 0.3s ease-out forwards',
            pointerEvents: 'none',
          }}
        />
      )}

      <style>{`
        @keyframes ghostFadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
      `}</style>
    </Box>
  );
}
